import { Compass, SlidersHorizontal } from "lucide-react";
import { AREAS } from "@/data/strategy";

const TIERS = [
  { key: "primary", title: "Azioni primarie", sub: "Da fare subito", color: "#C85A32", bg: "#FBF1EA" },
  { key: "secondary", title: "Azioni secondarie", sub: "Nei primi mesi", color: "#B07A12", bg: "#FDF6E6" },
  { key: "tertiary", title: "Azioni terziarie", sub: "Quando le prime sono avviate", color: "#6E8358", bg: "#F1F4EC" },
];

export const StrategyPanel = ({ strategy, onToggleWeights, weightsOpen }) => (
  <section className="card p-6 sm:p-9" data-testid="strategy-panel">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <Compass className="text-[#2D4030]" size={24} />
        <p className="eyebrow">Strategia e priorità, calcolate dalle risposte</p>
      </div>
      {onToggleWeights && (
        <button className="btn btn-ghost !min-h-[44px] text-sm no-print" onClick={onToggleWeights} data-testid="toggle-weights-btn">
          <SlidersHorizontal size={16} /> {weightsOpen ? "Nascondi pesi" : "Regola i pesi"}
        </button>
      )}
    </div>
    <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#2D4030] mt-2" data-testid="strategy-label">{strategy.label}</h2>
    {strategy.pace && <p className="text-[#5C4D46] mt-2" data-testid="strategy-pace">{strategy.pace}</p>}
    {!strategy.answered && <p className="text-[#7A6B63] mt-4">Servono più risposte per indicare le azioni.</p>}
    <div className="grid md:grid-cols-3 gap-5 mt-8">
      {TIERS.map((t) => (
        <div key={t.key} className="rounded-2xl p-5 border" style={{ background: t.bg, borderColor: `${t.color}55` }} data-testid={`tier-${t.key}`}>
          <p className="font-serif text-xl font-semibold" style={{ color: t.color }}>{t.title}</p>
          <p className="text-xs uppercase tracking-widest font-semibold text-[#8A7970] mt-0.5 mb-4">{t.sub}</p>
          {strategy[t.key].length === 0 ? (
            <p className="text-sm italic text-[#B0A096]">Nulla di rilevante emerso</p>
          ) : (
            <ol className="grid gap-4">
              {strategy[t.key].map((a, i) => (
                <li key={a.id} className="flex gap-3" data-testid={`action-${a.id}`}>
                  <span className="flex-none font-serif text-xl font-semibold leading-none mt-0.5" style={{ color: t.color }}>{i + 1}</span>
                  <div>
                    <p className="font-semibold text-[#2C221E] leading-snug">{a.title}</p>
                    <p className="text-xs uppercase tracking-wider text-[#8A7970] mt-1">{AREAS[a.area]}{a.weight !== 1 && <span className="ml-2 text-[#C85A32] normal-case tracking-normal" data-testid={`action-weight-${a.id}`}>peso ×{a.weight}</span>}</p>
                    {a.reasons.length > 0 && <p className="text-sm text-[#5C4D46] mt-1">{a.reasons.join(" · ")}</p>}
                  </div>
                </li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  </section>
);
